import { PropTypes } from 'prop-types';
export const DecodeHtml = ({ html }) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: html }} className=' flex flex-col'
            style={{
                whiteSpace: "wrap"
            }}
        >
        </div>
    )
}
DecodeHtml.propTypes = {
    html: PropTypes.string
}